import React, { useState } from 'react';
import { environment } from '../../environment';

import styles from './UserImage.module.scss'

const UserImage = ({ style='', path, name}) => {
  const [error, setError] = useState(false);

  const onErrorImage = () => {
    setError(true);
  };

  if(!path || error) return (
    <div className={`${style} ${styles.container}`}>
      <img src={environment.noAvatar} className={styles.image} draggable="false" onError={onErrorImage} alt={`Imagem padrão para usuários sem fotos`}/>
    </div>
  )
  
  return (
    <div className={`${style} ${styles.container}`}>
      <img className={styles.image} draggable="false" onError={onErrorImage} alt={`Foto do clube de ${name}`} src={path}/>
    </div>
  )
}

export default UserImage;